/* Edenworth desktop gallery. 2-column photo grid on computers (only the chosen colour).
   Turn it off in Brand style > Product page, computer. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(min-width: 990px)');
  function enabled() { return !window.EW_SET || window.EW_SET.galleryGrid !== false; }

  function css() {
    if (document.getElementById('ew-grid-css')) return;
    var s = document.createElement('style'); s.id = 'ew-grid-css';
    s.textContent =
      '.ew-ggrid{display:none}' +
      '@media (min-width:990px){' +
        '.ew-pdp__info{position:sticky;top:9rem;align-self:start}' +
        '.ew-gallery.has-grid{display:block!important}' +
        '.ew-gallery.has-grid .ew-gallery__thumbs,.ew-gallery.has-grid .ew-gallery__main{display:none!important}' +
        '.ew-gallery.has-grid .ew-ggrid{display:grid;grid-template-columns:1fr 1fr}' +
      '}' +
      '.ew-ggrid__item{position:relative;margin:0;aspect-ratio:1/1;overflow:hidden;background:var(--ew-bg2);cursor:zoom-in}' +
      '.ew-ggrid__item.is-wide{grid-column:span 2;aspect-ratio:2/1}' +
      '.ew-ggrid__item img,.ew-ggrid__item video,.ew-ggrid__item iframe{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border:0;display:block;transition:transform .6s ease}' +
      '.ew-ggrid__item.is-video{cursor:default}' +
      '.ew-lb{position:fixed;inset:0;z-index:1000;background:rgba(250,250,248,.97);display:flex;align-items:center;justify-content:center;cursor:zoom-out}' +
      '.ew-lb img{max-width:92vw;max-height:92vh;object-fit:contain}' +
      '.ew-lb button{position:absolute;top:50%;transform:translateY(-50%);width:4.8rem;height:4.8rem;border-radius:50%;border:1px solid var(--ew-line);background:#fff;font-size:2.2rem;line-height:1;cursor:pointer;color:var(--ew-ink)}' +
      '.ew-lb .p{left:2.4rem}.ew-lb .n{right:2.4rem}' +
      '.ew-lb .x{top:3.2rem;right:2.4rem;transform:none;font-size:2rem}';
    document.head.appendChild(s);
  }

  function visibleThumbs(gal) {
    return Array.prototype.filter.call(gal.querySelectorAll('.ew-gallery__thumb'), function (t) {
      return t.style.display !== 'none' && !t.hidden;
    });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!v.paused) v.pause();
    });
  }, { threshold: 0.35 }) : null;

  function lightbox(list, i) {
    var box = document.createElement('div'); box.className = 'ew-lb';
    box.innerHTML = '<img alt=""><button class="p" aria-label="Previous">&#8249;</button><button class="n" aria-label="Next">&#8250;</button><button class="x" aria-label="Close">&times;</button>';
    var img = box.querySelector('img');
    function go(k) { i = (k + list.length) % list.length; img.src = list[i]; }
    function close() { box.remove(); document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') go(i - 1); if (e.key === 'ArrowRight') go(i + 1); }
    box.addEventListener('click', function (e) {
      if (e.target.classList.contains('p')) return go(i - 1);
      if (e.target.classList.contains('n')) return go(i + 1);
      close();
    });
    document.addEventListener('keydown', key);
    if (list.length < 2) { box.querySelector('.p').remove(); box.querySelector('.n').remove(); }
    document.body.appendChild(box);
    go(i);
  }

  function build(gal) {
    var thumbs = visibleThumbs(gal);
    if (!enabled() || !MQ.matches || thumbs.length < 2) { gal.classList.remove('has-grid'); return; }
    var sig = thumbs.map(function (t) { return t.dataset.src || t.dataset.video || t.dataset.embed; }).join('|');
    var grid = gal.querySelector('.ew-ggrid');
    if (grid && grid.dataset.sig === sig) { gal.classList.add('has-grid'); return; }
    if (!grid) { grid = document.createElement('div'); grid.className = 'ew-ggrid'; gal.appendChild(grid); }
    grid.dataset.sig = sig;
    grid.innerHTML = '';
    var big = [];
    thumbs.forEach(function (t, n) {
      var f = document.createElement('figure'); f.className = 'ew-ggrid__item';
      if (t.dataset.type === 'image') {
        var img = document.createElement('img');
        img.alt = t.dataset.alt || '';
        img.loading = n < 2 ? 'eager' : 'lazy';
        if (t.dataset.srcset) { img.srcset = t.dataset.srcset; img.sizes = '(min-width: 990px) 32vw, 100vw'; }
        img.src = t.dataset.src;
        f.appendChild(img);
        var k = big.length; big.push(t.dataset.src.replace(/width=\d+/, 'width=2000'));
        f.addEventListener('click', function () { lightbox(big, k); });
      } else if (t.dataset.type === 'video') {
        f.classList.add('is-video');
        var v = document.createElement('video');
        v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('autoplay', '');
        v.preload = 'metadata';
        v.poster = t.dataset.poster || '';
        v.src = t.dataset.video;
        f.appendChild(v);
        if (io) io.observe(v);
      } else if (t.dataset.type === 'embed') {
        f.classList.add('is-video');
        f.innerHTML = '<iframe src="' + t.dataset.embed + '" allow="autoplay; encrypted-media" loading="lazy" title="Video"></iframe>';
      }
      grid.appendChild(f);
    });
    if (thumbs.length % 2 === 1) grid.lastElementChild.classList.add('is-wide');
    gal.classList.add('has-grid');
  }

  function init() {
    css();
    document.querySelectorAll('[data-ew-gallery]').forEach(function (gal) {
      build(gal);
      if (gal.dataset.ewGrid) return; gal.dataset.ewGrid = '1';
      var t = null;
      function later() { clearTimeout(t); t = setTimeout(function () { build(gal); }, 80); }
      var th = gal.querySelector('.ew-gallery__thumbs');
      if (th) new MutationObserver(later).observe(th, { attributes: true, subtree: true, attributeFilter: ['style', 'hidden', 'data-alt'] });
      if (MQ.addEventListener) MQ.addEventListener('change', later); else MQ.addListener(later);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();